import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
  name: 'layout',
  initialState: {
    collapsed: false,
  },
  reducers: {
    setCollapsed: (state, action) => {
      state.collapsed = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCollapsed } = slice.actions;

// Get value from state
export const layoutStore = (state) => state.layout;

export default slice.reducer;
